export default "__VITE_ASSET__CRlk3042__"